
import { computed, defineComponent, ref } from 'vue';
import { useRoute } from 'vue-router';
import { _MODAL_TYPE } from '@/enums';
import { $api } from '@/services';
import { useStore } from 'vuex';
import DownloadCSV from '@/mixins/downloadCSV.vue';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import Loading from '@/components/common/Loading.vue';
import GoalList from '@/components/elements/GoalList.vue';
import { ACTIONS } from '@/enums/Common';
import ConfirmSendReportTarget from '@/views/groupClassPlansDetail/features/reportFuture/confirmSendReportFuture/ConfirmSendReportFuture.vue';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';

export default defineComponent({
	name: 'GroupClassPlansDetailReport',
	components: {
		DaModalFrame,
		ConfirmSendReportTarget,
		GoalList,
		Loading,
		Menu,
		MenuItem,
		MenuItems,
		MenuButton,
	},
	setup() {
		const route = useRoute();
		const store = useStore();
		const report = ref(null as any);
		const stats = ref(null as any);
		const skills = ref([] as any);

		const isLoading = ref(true);
		const modalIsOpen = ref(false);
		const modalType = ref('');

		const id = computed(() =>
			route.params?.id ? route.params?.id + '' : ''
		);

		async function activePlans() {
			try {
				const {
					data: { data, stats: s, skills: sk },
				} = await $api.groupClasses.pendingReports(id.value);
				report.value = data;
				stats.value = s;
				skills.value = sk;
				isLoading.value = false;
			} catch (e) {
				console.log(e);
			}
		}

		function cancel() {
			modalIsOpen.value = false;
			modalType.value = '';
		}

		const type = computed(() => ACTIONS);
		const reportName = ref('');

		function confirmSendOpen() {
			modalIsOpen.value = true;
			reportName.value = report.value?.order || '';
			modalType.value = type.value.CREATE;
		}

		async function sendNotification() {
			try {
				await $api.groupClasses.sendReport(id.value, report.value?.id);
				cancel();
				await activePlans();
				await store.dispatch('setAlertMessage', {
					message: 'Gửi kế hoạch đến phụ huynh thành công',
				});
			} catch (err) {
				await store.dispatch('setAlertMessage', {
					message:
						err?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		}

		activePlans();

		return {
			id,
			modalIsOpen,
			modalType,
			report,
			stats,
			skills,
			modalTypes: computed(() => _MODAL_TYPE),
			org: computed(() => store.state.profile.current_org),
			isLoading,
			type,
			reportName,
			cancel,
			confirmSendOpen,
			sendNotification,
		};
	},
	mixins: [DownloadCSV],
});
